// extracted by mini-css-extract-plugin
module.exports = {"body":"_3KK_cD","footer":"_3hnCcM"};